export const statusNetworkInitialState = {
  hasNetwork: true,
  onlineMsg: false,
  isFormSubmited: false,
  deletedMsg: false,
  syncDoneMsg: false,
  syncLoading: false,
  syncStopped: false,
}
